import React from "react";
import { WhatsAppWidget } from "react-whatsapp-widget";
import "react-whatsapp-widget/dist/index.css";

export const WhatsAppChat = () => {
  const isMobileOrTablet = () => {
    return window.innerWidth <= 768;
  };

  if (isMobileOrTablet()) {
    return (
      <WhatsAppWidget
        companyName="Influx"
        replyTimeText={"Répond en quelques minutes"}
        message={
          "Posez-nous n'importe quelle question. On vous répond le plus vite possible ! 👋"
        }
        sendButtonText={"Envoyer"}
        inputPlaceHolder={"Votre message..."}
        phoneNumber="33682429958" // nico's
      />
    );
  } else {
    return null;
  }
};
